function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfettiStatic = function SvgConfettiStatic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 109,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M106.615 52.11l5.701 3.788L104.74 67.3l-5.701-3.79zM48.578 93l5.7 3.789-7.576 11.401L41 104.402zM14.207 30.434l5.7 3.789-7.577 11.401-5.7-3.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.accentFill,
    d: "M71.689 28.292l6.781-.934 1.868 13.562-6.781.934zM11.595 68.73l-1.193 5.165-10.33-2.387 1.193-5.165zM35.523 87.386l-1.193 5.165L24 90.165 25.193 85zM59.617 57.813l4.862 4.818-9.637 9.724-4.862-4.819zM65.637 92l4.862 4.819-9.637 9.723L56 101.724z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32 57.035l10.29-4.925 6.764 22.058-4.116 1.97L20.32 57.036zM50.764 0h11.408L58.75 22.817h-4.564L50.764 0zM79.6 52.11l10.465 4.541L77.842 76.22l-4.186-1.816L79.6 52.109z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 44.631,
    r: 3,
    fill: props.fill
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 85,
    r: 3,
    fill: props.fill
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 77.631,
    r: 3,
    fill: props.accentFill
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 26.631,
    r: 3,
    fill: props.fill
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20.631,
    r: 3,
    fill: props.accentFill
  }));
};
export default SvgConfettiStatic;